<script setup>
import Button from "primevue/button";
import {computed} from "vue";
import {useRentalItemTypes} from "../../../helpers/useRentalItemTypes.js";

const props = defineProps({
    formType: { type: String, default: 'rental' },
})

const selectedType = defineModel();

const visibleItems = computed(() => {
    const all = useRentalItemTypes().rentalItemTypes;
    if (props.formType === 'accommodation') {
        return all.filter(t => t.category === 'accommodation' || t.category === 'both');
    }
    return all.filter(t => t.category === 'rental' || t.category === 'both');
});
</script>

<template>
<div class="flex flex-wrap gap-4">
    <Button v-for="item in visibleItems" :key="item.type" :icon="item.icon" :label="item.name" outlined severity="secondary" @click="selectedType = item.type" rounded></Button>
    <Button :label="$t('rental.type_other')" @click="selectedType = 'other'" icon="pi pi-ellipsis-h" outlined rounded></Button>
</div>
</template>

<style scoped lang="scss">

</style>
